import {useEffect, useState} from "react";
import {deleteCity, getCities} from "../../services/CitiesService";
import {Link} from "react-router-dom";
import {getCompanyId} from "../../config";

const CitiesList = () => {
    const [state, setState] = useState({
        cities: [],
        loading: false,
        isDeleted: false,
    });

    const __init = async () => {
        const companyId = await getCompanyId()
        const cities = await getCities(companyId);
        setState({...state, cities})
    }

    const onDelete = async (id: number) => {
        const isDeleted = await deleteCity(id);

        if (isDeleted){
            setState({...state, isDeleted: true});
        }
    };

    useEffect(()=> {
        __init()
    },[state.isDeleted]);

    const renderPrices = () => {
        return (
            state.cities.map((city: any) => (
                <tr key={city.id}>
                    <td>{city.name}</td>
                    <td>{city.price}</td>
                    <td>
                        <div className="btn-group btn-group-sm">
                            <Link to={`/cities/${city.id}`} className="btn btn-warning"><i className="fas fa-edit"></i></Link>
                            <a href="javascript:void(0)" className="btn btn-danger" onClick={() => onDelete(city.id)}><i className="fas fa-trash"></i></a>
                        </div>
                    </td>
                </tr>
            ))
        );
    }

    return (
        <div className="content-header">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title text-uppercase">Cities list</h3>
                            </div>

                            <div className="card-body table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>City name</th>
                                        <th>Price</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {renderPrices()}
                                    </tbody>
                                </table>
                            </div>

                            <div className="card-footer">
                                <Link to={'/cities/create'} className="btn btn-info">
                                    Create new
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CitiesList;